export default {
  stringFormat(date: string, separator = ".") {
    if(!date) return ""
    const dt = new Date(date)
    const year = dt.getFullYear()
    const month = dt.getMonth() + 1
    const day = dt.getDate();
    const hour = dt.getHours() >= 10 ?  dt.getHours() : "0" + dt.getHours()
    const minutes = dt.getMinutes() >= 10 ?  dt.getMinutes() : "0" + dt.getMinutes()
    return `${year}${separator}${month >= 10 ? month : "0"+month}${separator}${day >= 10 ? day : "0"+day} ${hour}:${minutes}`
  },
  dateToString(dt: Date) {
    if (!dt) return ""
    const year = dt.getFullYear()
    const month = dt.getMonth() + 1
    const day = dt.getDate();
    const hour = dt.getHours() >= 10 ?  dt.getHours() : "0" + dt.getHours()
    const minutes = dt.getMinutes() >= 10 ?  dt.getMinutes() : "0" + dt.getMinutes()
    const second = dt.getSeconds() >= 10 ?  dt.getSeconds() : "0" + dt.getSeconds()
    return `${year}-${month >= 10 ? month : "0"+month}-${day >= 10 ? day : "0"+day} ${hour}:${minutes}:${second}`
  }
}